import React from 'react';
import { Button } from 'antd';
import { t } from '../../../helpers/t';

export default function ClearButton({ onClick, style }) {

  return (
    <Button
      type="link"
      size="small"
      className="clear-button pull-right"
      onClick={onClick}
      style={style || {}}
    >
      {t('directives.listings.listingFilters.clear')}
    </Button>
  );
}
